import React from 'react';
import StudentCard from '../StudentCard/StudentCard.js';
import styles from './ProfessorPositions.module.css'; // Add this import

function MatchesModal({
  isOpen,
  onClose,
  positionTitle,
  matches,
  isLoading
}) {
  const [animate, setAnimate] = React.useState(false);

  React.useEffect(() => {
    if (isOpen && !isLoading) {
      const timer = setTimeout(() => setAnimate(true), 100);
      return () => clearTimeout(timer);
    } else {
      setAnimate(false);
    }
  }, [isOpen, isLoading]);

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderContent}>
            <h2 className={styles.modalTitle}>Candidate Matches</h2>
            <button onClick={onClose} className={styles.modalCloseButton} aria-label="Close modal">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <p className={styles.modalSubtitle}>
            Position: <span className={styles.positionHighlight}>{positionTitle}</span>
          </p>
        </div>

        <div className={styles.modalBody}>
          {isLoading ? (
            <div className={styles.loadingState}>
              <div className={styles.loadingSpinner}></div>
              <p className={styles.loadingTitle}>Finding the best matches...</p>
              <p className={styles.loadingDescription}>This may take a few moments</p>
            </div>
          ) : matches.length === 0 ? (
            <div className={styles.emptyMatchesState}>
              <div className={styles.emptyMatchesIcon}>
                <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                </svg>
              </div>
              <h3 className={styles.emptyMatchesTitle}>No matches found</h3>
              <p className={styles.emptyMatchesDescription}>
                We couldn't find any candidates that match your position requirements at this time.
                Try adjusting your position criteria or check back later for new candidates.
              </p>
            </div>
          ) : (
            <div className={styles.matchesContent}>
              <div className={styles.matchesHeader}>
                <h3 className={styles.matchesCount}>
                  Found {matches.length} matching candidate{matches.length !== 1 ? 's' : ''}
                </h3>
                <div className={styles.matchesSortInfo}>
                  Sorted by compatibility score
                </div>
              </div>
              <div className={styles.matchesGrid}>
                {matches.map((student, index) => {
                  const score = student.matchScore || 0;
                  const percentage = Math.round(score * 100);

                  return (
                    <div key={student._id || index} className={styles.matchCardWrapper}>
                      <div className={styles.matchBarContainer}>
                        <div className={styles.matchBarEmpty}></div>
                        <div
                          className={styles.matchBarFill}
                          style={{ width: animate ? `${percentage}%` : '0%' }}
                        >
                          <div className={styles.matchPercentageLabel}>
                            <span className={styles.matchPercentageValue}>{percentage}%</span>
                            <span className={styles.matchLabel}>Match</span>
                          </div>
                        </div>
                      </div>
                      <StudentCard student={student} />
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MatchesModal;
